import { defineComponent, computed } from '@vue/composition-api';
import ModalPopup from '@/shared/components/ModalPopup.vue';
import { SpaceRoutes } from '@/Space/space.const';
import { VenueRoutes } from '@/Venue/venue.const';
import { useToast } from 'vue-toastification/composition';
export default defineComponent({
    components: {
        ModalPopup
    },
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
    setup(props, context) {
        const { root } = context;
        const toast = useToast();
        const options = [
            {
                name: 'facebook',
                social: true,
                iconName: 'fa-brands fa-facebook fa-lg pre-icon'
            },
            {
                name: 'twitter',
                social: true,
                iconName: 'fa-brands fa-x-twitter fa-lg pre-icon'
            },
            {
                name: 'linkedin',
                social: true,
                iconName: 'fa-brands fa-linkedin fa-lg pre-icon'
            },
            {
                name: 'copy',
                social: false,
                iconName: 'fa-solid fa-copy fa-lg pre-icon'
            },
            {
                name: 'email',
                social: true,
                iconName: 'fa-solid fa-envelope fa-lg pre-icon'
            }
        ];
        const sharedData = computed(() => {
            if (!props.data)
                return {};
            let model;
            let modelName;
            let modelDescription;
            if (props.data.venue_id || props.data.venueId) {
                model = 'venue';
                modelName = props.data.venue_name || props.data.venueName;
                modelDescription =
                    props.data.venue_description || props.data.description;
            }
            else {
                model = 'space';
                modelName = props.data.internal_name
                    ? `${props.data.venue.venue_name} - ${props.data.internal_name}`
                    : props.data.space_name || props.data.name;
                modelDescription = `${root.$i18n.t('filter.label_price_from', {
                    price: props.data.half_day_price
                })} ${props.data.space_booking_type === 'DIRECT'
                    ? root.$i18n.t('filter.label_direct')
                    : ''}`;
            }
            const route = model === 'venue' ? VenueRoutes.VENUE : SpaceRoutes.SPACE;
            const spaceUrl = props.data.space_url || props.data.spaceUrl;
            const venueUrl = props.data.venue_url || props.data.venueUrl;
            const url = model === 'venue' ? venueUrl : spaceUrl;
            return {
                name: modelName,
                description: modelDescription,
                link: `${window.location.origin}/${route}${url}`
            };
        });
        const copyLink = () => {
            root.$copyText(sharedData.value.link);
            toast.success(root.$i18n.t('common.social_sharing.link_copied'));
        };
        const onSocialShareButtonClick = (socialNetworkName) => {
            if (!socialNetworkName || !props.data)
                return;
            // Track event
            globalThis.$gtm.trackEvent({
                event: `${props.data.venue_id ? 'venue' : 'space'}_social_share`,
                category: 'social',
                action: `${props.data.venue_id ? 'venue' : 'space'}_shared_` +
                    socialNetworkName,
                label: `${props.data.venue_id ? 'venue' : 'space'}_social_share`,
                value: socialNetworkName,
                noninteraction: false
            });
        };
        return {
            options,
            sharedData,
            copyLink,
            onSocialShareButtonClick
        };
    }
});
